export enum TotalPriceStatus {
  Unknown = 'NOT_CURRENTLY_KNOWN',
  Estimated = 'ESTIMATED',
  Final = 'FINAL',
}
